export const daysOfTheWeek = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"]

export const getDayOfTheWeekName = (dayNo) => {
  return daysOfTheWeek[dayNo]
}



// WEBPACK FOOTER //
// ./src/helpers/week.js